import { styled } from '@mui/material/styles';
import AccountCredentialsButton from '../../../account-credentials-button/account-credentials-button';

export const StyledAccountCredentialsButton = styled(AccountCredentialsButton)(
  ({ theme }) => {
    const size = theme.spacing(12);

    return {
      width: size,
      height: size,
      minWidth: size,
      minHeight: size,
      maxWidth: size,
      maxHeight: size,
      flexShrink: 0,
      zIndex: theme.zIndex.tooltip,
    };
  },
);
